import React, { useEffect, useState } from "react";
import { Box, Typography, CircularProgress, Stack } from "@mui/material";
import NoRecordsFound from "components/Records/NoRecordsFound";

import TabPanel from "./TabPanel";

import { getAllInteractionLogsByPerson } from "api/Community/PeopleAPI";
import { UnifiedInteractionLog } from "api/Community/CommunityInterfaces";
import InteractionCard from "components/Interactions/InteractionCard";

interface Props {
  tabIndex: number;
  index: number;
  peopleId: number;
}

const PeopleInteractionHistoryTab: React.FC<Props> = ({
  tabIndex,
  index,
  peopleId,
}) => {
  const [logs, setLogs] = useState<UnifiedInteractionLog[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!peopleId) return;

    setLoading(true);
    setError(null);

    getAllInteractionLogsByPerson(peopleId)
      .then((data) => setLogs(data))
      .catch((err) => {
        console.error("Error fetching interaction logs:", err);
        setError(err?.message || "Failed to fetch interaction history.");
      })
      .finally(() => setLoading(false));
  }, [peopleId]);

  return (
    <TabPanel value={tabIndex} index={index}>
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error" sx={{ mt: 2 }}>
          Error loading interaction history: {error}
        </Typography>
      ) : !logs.length ? (
        <NoRecordsFound itemName="interaction logs" minHeight={50} maxHeight={100} />
      ) : (
        <Stack spacing={2}>
          {logs.map((log) => (
            <InteractionCard key={`${log.interaction_type}-${log.id}`} log={log} />
          ))}
        </Stack>
      )}
    </TabPanel>
  );
};

export default PeopleInteractionHistoryTab;
